import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/whg-park/api/placeManage/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/whg-park/api/placeManage/get',
    method: 'post',
    data: data
  });
}
export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/whg-park/api/placeManage/delete',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/whg-park/api/placeManage/insert',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/whg-park/api/placeManage/update',
    method: 'post',
    data: data
  });
}
export function lightOpen(data) {
  return request({
    url: '/whg-park/api/placeManage/lightOpen',
    method: 'post',
    data: data
  });
}
export function lightClose(data) {
  return request({
    url: '/whg-park/api/placeManage/lightClose',
    method: 'post',
    data: data
  });
}